import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import classNames from 'classnames';
import { ProductListSort } from '@/types/api';
import { Button } from '@/features/button';
import { IconSort } from '@/features/icons';
import { SORT_TITLES } from '../constants';
interface Props {
  isSelected: boolean;
  defaultSelected: ProductListSort;
  changeHandler: (newState: ProductListSort) => void;
}
const DesktopSortList = ({
  isSelected,
  defaultSelected,
  changeHandler
}: Props) => {
  return <Listbox value={defaultSelected} onChange={changeHandler} data-sentry-element="Listbox" data-sentry-component="DesktopSortList" data-sentry-source-file="desktop-sort-list.tsx">
            <div className='relative'>
                <ListboxButton as='div' data-sentry-element="ListboxButton" data-sentry-source-file="desktop-sort-list.tsx">
                    <Button id='sort-list-button' size='small' graphicStyle='text' icon={{
          position: 'right',
          element: <IconSort className='h-5 w-5 lg:h-6 lg:w-6' />
        }} data-sentry-element="Button" data-sentry-source-file="desktop-sort-list.tsx">
                        {isSelected ? SORT_TITLES[defaultSelected] : 'مرتب سازی'}
                    </Button>
                </ListboxButton>

                <ListboxOptions transition className='absolute left-0 z-20 mt-0 flex w-full min-w-[164px] cursor-pointer flex-col overflow-auto rounded border border-border-pink bg-white p-1 leading-9 shadow-sm focus:outline-none' data-sentry-element="ListboxOptions" data-sentry-source-file="desktop-sort-list.tsx">
                    {Object.keys(ProductListSort).map(item => <ListboxOption key={item} value={item} as={'div'}>
                            {({
            focus
          }) => <span className={classNames({
            'cursor-pointer': focus
          })}>
                                    <span className='px-2 py-1.5 text-body-16 text-neutral-800'>
                                        {SORT_TITLES[item as ProductListSort]}
                                    </span>
                                </span>}
                        </ListboxOption>)}
                </ListboxOptions>
            </div>
        </Listbox>;
};
export default DesktopSortList;